package com.ijoin.platform

import androidx.compose.runtime.Composable

@Composable
actual fun BackHandler(
    enabled: Boolean,
    onBack: () -> Unit
) {
    // Web doesn't have a system back button in the same way
}

